import { SidebarLeft } from "components/ui/SidebarLeft/SidebarLeft"
import style from "./NavMenu.module.scss"

const { menu, ul, li, active } = style

type Props = { listItemHandle: (index: number) => void; menuItemIndex: number }

export const NavMenu = ({ listItemHandle, menuItemIndex }: Props) => {
	return (
		<SidebarLeft>
			<nav className={menu}>
				<ul className={ul}>
					<li className={`${li} ${menuItemIndex === 0 ? active : ""}`} onClick={() => listItemHandle(0)}>
						<span>Versions</span>
					</li>
					<li className={`${li} ${menuItemIndex === 1 ? active : ""}`} onClick={() => listItemHandle(1)}>
						<span>Changelog</span>
					</li>
				</ul>
			</nav>
		</SidebarLeft>
	)
}
